import type { MessageKey } from './de.ts';

// English is prepared but not complete; missing keys fall back to German.
export const en: Partial<Record<MessageKey, string>> = {
  'app.claim': 'Making energy future-proof',
  'nav.dashboard': 'Overview',
  'nav.charging': 'Charging',
  'nav.heatpump': 'Heat pump',
  'nav.battery': 'Battery',
  'nav.grid': 'Grid',
  'nav.history': 'History',
  'auth.title': 'Sign in',
  'auth.email': 'Email',
  'auth.password': 'Password',
  'auth.submit': 'Sign in',
  'auth.logout': 'Sign out',
};
